import { useEffect, useState } from "react";
import axios from "axios";
import { Trophy } from "lucide-react";
import { fmtMoney } from "@/lib/data";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AwardNotice({ tenderId }) {
  const [notice, setNotice] = useState(null);

  useEffect(() => {
    axios.get(`${API}/tenders/${tenderId}/award-notice`).then((r) => setNotice(r.data)).catch(() => {});
  }, [tenderId]);

  if (!notice) return null;

  return (
    <div className="bg-emerald-50 border border-emerald-300 p-6 mb-8 flex flex-col md:flex-row md:items-center gap-5" data-testid="award-notice">
      <div className="w-11 h-11 bg-emerald-600 flex items-center justify-center shrink-0">
        <Trophy className="w-6 h-6 text-white" aria-hidden="true" />
      </div>
      <div className="flex-1">
        <p className="text-[11px] uppercase tracking-[0.25em] text-emerald-700 font-semibold mb-1">Public Award Notice · {notice.reference_number}</p>
        <p className="text-sm text-slate-700 leading-relaxed">
          Contract awarded to <strong data-testid="award-notice-vendor">{notice.vendor_name}</strong> ({notice.vendor_country})
          {notice.total_score != null && <> with a combined evaluation score of <span className="font-mono font-semibold">{notice.total_score}/100</span></>}.
        </p>
      </div>
      <div className="text-left md:text-right shrink-0">
        <p className="text-[11px] uppercase tracking-[0.15em] text-emerald-700">Contract Value</p>
        <p className="font-mono text-xl font-semibold text-slate-900" data-testid="award-notice-value">{fmtMoney(notice.bid_amount, notice.currency)}</p>
        {notice.awarded_at && <p className="text-xs text-slate-400 mt-0.5">Awarded {notice.awarded_at.slice(0, 10)}</p>}
      </div>
    </div>
  );
}
